import findCheapestTourV2PurchasableOption from './findCheapestTourV2PurchasableOption'

export default function findCheapestTourV2Variation(offer: Tours.V2Offer): Tours.V2OfferVariation {
  const cheapestPurchasableOption = findCheapestTourV2PurchasableOption(offer)
  const cheapestDeparture = offer.departures[cheapestPurchasableOption.fkDepartureId]
  const cheapestVariation = offer.variations[cheapestDeparture.fkVariationId]

  return cheapestVariation
}
